export class AysFab {

  constructor(
    public fabKey: string,
    public name: string
  ) {

  }
}

export interface AysFabKeyGroup {
  name: string;
  options: AysFab[];
  sortingIndex: number;
  disabled?: boolean;
}
